import { generatePath } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useDependencies } from '../../../dependencies';
import { Routes } from '../../../Routes';
import { Link } from '../..';
import Social from './Social';

export const MobileFooter = (): JSX.Element => {
  const { t } = useTranslation();
  const { stores } = useDependencies();
  const { user } = stores.user;
  const id = user.id?.toString() ?? '';
  const isParent = user!.parent;

  return (
    <div className='container text-sm block lg:hidden'>
      <div className='flex mb-6'>
        <div className='w-1/2'>
          <h4 className='font-bold text-base mb-2'>{t('components.footer.discover')}</h4>
          <Link className='block py-1 my-1' to={Routes.public.trust} newTab externalUS>
            {t('components.footer.trustAndSafety')}
          </Link>
          <Link className='block py-1 my-1' to={Routes.public.giftCards} newTab externalUS>
            {t('components.footer.giftCards')}
          </Link>
          {isParent && (
            <Link className='block py-1 my-1' to={Routes.parent.packages}>
              {t('components.footer.pricing')}
            </Link>
          )}
          <Link
            className='block py-1 my-1'
            to='https://blog.urbansitter.com/child-care-resources-for-parents/'
            newTab
            externalUS
          >
            {t('components.footer.resources')}
          </Link>
          <Link className='block py-1 my-1' to={generatePath(Routes.parent.explore, { id })}>
            {t('components.footer.explore')}
          </Link>
          <Link className='block py-1 my-1' to={Routes.support} newTab externalUS>
            {t('components.footer.support')}
          </Link>
        </div>
        <div className='w-1/2'>
          <h4 className='font-bold text-base mb-2'>{t('components.footer.company')}</h4>
          <Link className='block py-1 my-1' to={Routes.public.aboutUs} newTab externalUS>
            {t('components.footer.aboutUs')}
          </Link>
          <Link className='block py-1 my-1' to={Routes.public.privacyPolicy} newTab externalUS>
            {t('components.footer.privacy')}
          </Link>
          <Link className='block py-1 my-1' to={Routes.public.terms} newTab externalUS>
            {t('components.footer.terms')}
          </Link>
          <Link className='block py-1 my-1' to={Routes.public.careers} newTab externalUS>
            {t('components.footer.careers')}
          </Link>

          <div className='mt-6 hidden md:block'>
            <Social additionalId='tablet-' />
          </div>
          <div className='mt-6 text-xs hidden sm:block'>
            <span>&copy; {t('components.footer.copyright')}</span>
          </div>
        </div>
      </div>
      <div className='mb-6 block md:hidden'>
        <Social additionalId='mobile-' />
      </div>
      <div className='text-xs block sm:hidden'>
        <span>&copy; {t('components.footer.copyright')}</span>
      </div>
    </div>
  );
};
